import React, { useState } from "react";

import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import ChevronDown from "../../autorizaciones/UI/ChevronDown";

export const GAccordion = ({ children, disabled, startOpen = false, title, onClick = () => {} }) => {
    const [open, setOpen] = useState(startOpen);
    
    return (
        <Accordion 
            expanded={open} 
            onChange={() => {
                if(!open) onClick();
                setOpen(!open);
            }}
            disabled={disabled}
        >
            <AccordionSummary expandIcon={<ChevronDown />}>
                {title}
            </AccordionSummary>
            <AccordionDetails>
                {children}
            </AccordionDetails>
        </Accordion>
    );
};
